import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-11.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/fresh-pasta/fresh-pasta-12.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/about-us.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/buffet-1.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/buffet-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-1.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-3.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-4.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-5.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-6.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-7.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-8.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/dish-9.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homepage/table.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/residence/residence-1.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/app/src/components/reviews.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/ui/separator.tsx");
